import type { ToneOverlay } from "../index.js";

// Voz "avó" em português: carinho, preocupação, sopa e "veste um casaco". Como a "dark", é
// uma voz para aliviar o ambiente, por isso as linhas rodam a cada duas horas
// (TONE_ROTATE_MS). Cada variante mantém os {marcadores} da base.
export const overlay: ToneOverlay = {
  "alert.toast.new": [
    "{hazard} aí perto, ó filho — atenção agora",
    "{hazard} aqui ao pé, meu rico. Olho vivo.",
    "{hazard} por perto — não gosto nada disto. Cuidado.",
    "{hazard} perto. Tem cuidado, ouviste?",
    "{hazard} aqui perto. Não te afastes, sim?",
  ],
  "alert.toast.escalation": [
    "O {hazard} está a piorar, não esperes, ouve a avó",
    "O {hazard} cresce, ó filho — mexe-te já",
    "{hazard} pior agora. Não sejas teimoso, vai.",
    "{hazard} a alastrar. Valha-me Nossa Senhora. Despacha-te.",
  ],
  "alert.toast.inPath": [
    "O {hazard} vem na tua direção — mexe-te, meu rico",
    "{hazard} vem aí, filho — vai, vai",
    "{hazard} vem a por ti. Anda, anda, mexe-te!",
    "{hazard} quase à porta — sai já, por amor de Deus",
  ],
  "alert.toast.allClear": [
    "Tudo calmo perto de {place}, graças a Deus",
    "{place} está sossegado. Senta-te, respira.",
    "Em segurança perto de {place}, ó filho. Que aflição.",
    "Tudo bem perto de {place}. Agora bebe água.",
  ],
  "alert.toast.tap": [
    "Anda cá, toca aqui — a avó diz-te o que fazer",
    "Toca, meu rico — eu explico-te",
    "Toca aqui. A avó tem um plano.",
  ],
  "alert.takeover.title": [
    "{hazard} — vá, mexe-te já, não discutas com a avó",
    "{hazard} — anda, anda! Vai, é a sério",
    "{hazard} — deixa-te de conversa, mexe-te, filho",
  ],
  "alert.takeover.details": "Mostra-me lá tudo",
  "alert.takeover.dismiss": "Está bem, está bem",
  "now.status.allClear": [
    "Tudo calmo, meu rico.",
    "Sossegado agora, ó filho.",
    "Está tudo bem — senta-te, descansa.",
    "Tudo bem. Já comeste?",
    "Calmo, graças a Deus.",
    "Sossegadinho. Descansa um bocadinho.",
    "Em paz agora. E veste um casaco.",
  ],
  "now.status.stayAware": [
    "Olho vivo, ouviste?",
    "Atenção, meu rico.",
    "Presta atenção, faz isso pela avó.",
    "Cuidado, sim?",
    "Não te afastes, anda.",
  ],
  "now.status.sub.allClear": [
    "Nada por perto agora. Bebe água.",
    "Tudo calmo. Já comeste alguma coisa?",
    "Nada no teu raio. Senta-te um bocadinho.",
    "Limpo por agora, filho. Respira.",
    "Nada por perto. Veste um casaco na mesma.",
  ],
  "now.activity.empty": [
    "Sossegado por agora. Já comeste?",
    "Não se passa nada. Descansa um bocadinho.",
    "Tudo calmo. Liga à tua mãe, ouviste?",
    "Nada por aqui, meu rico. Toma uma sopinha.",
    "Vazio e sossegado. Aproveita, filho.",
  ],
  "onboarding.promise.tagline": "Vizinhos a cuidar de vizinhos, como família.",
  "onboarding.promise.continue": "Entra, entra",
  "onboarding.home.browse": "Só a ver, por agora",
  "you.voice.intro": "Diz-me como gostas que fale contigo, meu rico.",
};
